import type { AuthenticatedUser as User } from '../auth.server.js';
import { useOptionalRouteData } from '../root.js';

function isUser(user: unknown): user is User {
  return (
    !!user &&
    typeof (user as User).token === 'string' &&
    typeof (user as User).email === 'string'
  );
}

export function useOptionalUser(): User | undefined {
  // optional (not required) route data: error boundaries can render without
  // root loader data, and a missing user is a valid result here
  const data = useOptionalRouteData();
  if (!data || !isUser(data.user)) {
    return undefined;
  }
  return data.user;
}

export function useRequiredUser(): User {
  const maybeUser = useOptionalUser();
  if (!maybeUser) {
    throw new Error(
      'A logged-in user is required but was not found. If user is optional, try useOptionalUser instead.'
    );
  }
  return maybeUser;
}

export type { User };
